exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-card-2xp1Z{background-color:#fff;border-radius:var(--container-border-radius);padding:16px;font-size:var(--font-size-base)}.card-padding-small-3hcNe{padding:8px}.card-padding-medium-3K3NW{padding:16px}.card-padding-large-1AKsd{padding:24px 32px}", ""]);

// exports
exports.locals = {
	"card": "card-card-2xp1Z",
	"padding-small": "card-padding-small-3hcNe",
	"paddingSmall": "card-padding-small-3hcNe",
	"padding-medium": "card-padding-medium-3K3NW",
	"paddingMedium": "card-padding-medium-3K3NW",
	"padding-large": "card-padding-large-1AKsd",
	"paddingLarge": "card-padding-large-1AKsd"
};